<template>
  <div class="emat-info">
    <lord-icon
      v-if="canShow"
      class="lord-icon emat-info-icon"
      src="https://cdn.lordicon.com/meypkgwe.json"
      trigger="hover"
      :colors="lordIconColors('--c-btn-close-background')"
      style="max-width: 24px; max-height: 24px"
      stoke="100"
      @click="show = true"
    />

    <template v-if="type === 'modal'">
      <PopupBase :menu="show" @close="show = false">
        <template #header>{{ title }}</template>
        <template #body>
          <vue-markdown>{{ actualContent }}</vue-markdown>
        </template>
        <template #footer v-if="link">
          <a :href="link" target="_blank" class="link">
            {{ linkText ? linkText : 'Meer informatie' }}
          </a>
        </template>
      </PopupBase>
    </template>
    <template v-else>
      <div class="emat-info-backdrop" @click="show = false" v-if="show"></div>
      <div class="emat-info-popup" v-if="show">
        <div class="emat-info-close" @click="show = false"></div>
        <h4 class="title" v-if="title">{{ title }}</h4>
        <vue-markdown>{{ actualContent }}</vue-markdown>
        <a v-if="link" :href="link" target="_blank" class="link">
          {{ linkText ? linkText : 'Meer informatie' }}
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import PopupBase from '../../Layout/Popup';
import VueMarkdown from 'vue-markdown';
import lordIcons from '../../../mixins/lordIcons.js';

export default {
  name: 'Info',
  mixins: [lordIcons],
  components: {
    VueMarkdown,
    PopupBase,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    content: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'popup',
      validator: (value) => ['popup', 'modal'].includes(value),
    },
    linkText: {
      type: String,
      default: null,
    },
    info: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    canShow() {
      return this.title || this.content || this.link;
    },
    actualContent() {
      // for backwards compatibility
      return this.content || this.info;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/abstracts";

.emat-info {
  position: relative;
  display: flex;
  align-items: center;

  .emat-info-icon {
    position: relative;
    outline: none;
    cursor: pointer;
    margin-right: 4px;
  }

  .emat-info-backdrop {
    background-color: rgba(0, 0, 0, .5);
    position: fixed;
    z-index: 5;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }

  .emat-info-popup {
    box-sizing: border-box;
    padding: 20px;
    background: #fff;
    position: absolute;
    left: 30px;
    top: -16px;
    width: 100vw;
    max-width: 300px;
    min-height: 150px;
    z-index: 5;
    border-radius: $border-radius;
    box-shadow: -2px 0 15px rgba(0, 0, 0, .1);
    font-family: var(--font);

    &:after {
      content: "";
      display: block;
      height: 10px;
      width: 10px;
      background: inherit;
      position: absolute;
      top: 18px;
      left: 0;
      transform: translateX(-50%) rotate(45deg);
    }
  }

  .title {
    padding-right: 20px;
    color: var(--c-primary);
    font-family: var(--font-heading);
    margin: 0 0 12px 0;
  }

  .emat-info-close {
    width: 20px;
    height: 20px;
    position: relative;
    float: right;
    margin-top: -4px;
    cursor: pointer;

    &:before,
    &:after {
      content: "";
      display: block;
      height: 2px;
      width: 18px;
      background: var(--c-emat-dark);
      position: absolute;
      top: 50%;
      left: 50%;
    }

    &:before {
      transform: translateX(-50%) translateY(-50%) rotate(45deg);
    }

    &:after {
      transform: translateX(-50%) translateY(-50%) rotate(-45deg);
    }
  }

  ::v-deep iframe,
  ::v-deep img {
    max-width: 100%;
  }

  ::v-deep table {
    width: 100%;
    border-collapse: collapse;

    &,
    th,
    td {
      border: 1px solid rgba(0, 0, 0, 0.1);
    }

    th,
    td {
      text-align: left;
      padding: 5px 14px 5px 12px;
    }

    th {
      background-color: #555;
      color: #fff;
      height: 32px;
      font-weight: 300;
    }
  }

  ::v-deep .emat-popup-card-body,
  ::v-deep .emat-popup-card-footer {
    padding: 20px !important;
  }
}
</style>
